/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/privacidad.jpg"; // Reusing generic background

function Privacy() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <MKBox sx={{ backgroundColor: "rgba(17, 88, 194, 0.54)" }}>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/landing-pages/contact-us",
          label: "contáctanos",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="40vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Aviso de Privacidad
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: isDarkMode ? "background.paper" : "white",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={6}>
          <Container>
            <Grid container item xs={12} lg={8} sx={{ mx: "auto" }}>
              <MKTypography variant="body1" color={isDarkMode ? "white" : "text"} mb={3}>
                <strong>Título:</strong> Aviso de Privacidad Integral
              </MKTypography>

              <MKTypography variant="h5" color={isDarkMode ? "white" : "dark"} mt={4} mb={2}>
                1. Responsable de la protección de sus datos personales
              </MKTypography>
              <MKTypography variant="body1" color={isDarkMode ? "white" : "text"} mb={1}>
                Impresia S.A. de C.V., con domicilio en Querétaro, Querétaro, es el responsable del
                uso, manejo y protección de los datos personales proporcionados por nuestros
                clientes, proveedores y usuarios.
              </MKTypography>

              <MKTypography variant="h5" color={isDarkMode ? "white" : "dark"} mt={4} mb={2}>
                2. ¿Para qué fines recabamos y utilizamos sus datos personales?
              </MKTypography>
              <MKTypography variant="body1" color={isDarkMode ? "white" : "text"} mb={1}>
                Su información personal será utilizada exclusivamente para las siguientes
                finalidades necesarias para el servicio que solicita:
                <ul>
                  <li>Venta de productos de papelería y artículos de impresión.</li>
                  <li>Prestación de servicios de impresión.</li>
                  <li>Gestión y procesamiento de pedidos.</li>
                  <li>Facturación y cobranza.</li>
                  <li>Soporte técnico y atención al cliente.</li>
                  <li>Seguimiento comercial.</li>
                </ul>
              </MKTypography>

              <MKTypography variant="h5" color={isDarkMode ? "white" : "dark"} mt={4} mb={2}>
                3. Protección de Datos
              </MKTypography>
              <MKTypography variant="body1" color={isDarkMode ? "white" : "text"} mb={1}>
                Impresia garantiza la confidencialidad de los datos conforme a lo establecido por la
                Ley Federal de Protección de Datos Personales en Posesión de los Particulares,
                adoptando las medidas de seguridad administrativas, técnicas y físicas necesarias
                para su resguardo y uso adecuado.
              </MKTypography>

              <MKTypography variant="h5" color={isDarkMode ? "white" : "dark"} mt={4} mb={2}>
                4. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)
              </MKTypography>
              <MKTypography variant="body1" color={isDarkMode ? "white" : "text"} mb={1}>
                Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los
                utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho
                solicitar la corrección de su información personal en caso de que esté
                desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de
                nuestros registros o bases de datos cuando considere que la misma no está siendo
                utilizada conforme a los principios, deberes y obligaciones previstas en la
                normativa (Cancelación); así como oponerse al uso de sus datos personales para fines
                específicos (Oposición).
              </MKTypography>
              <MKTypography variant="body1" color={isDarkMode ? "white" : "text"} mt={2}>
                Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la
                solicitud respectiva a través del siguiente correo electrónico:{" "}
                <strong>privacidad@impresia.com.mx</strong>.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </MKBox>
  );
}

export default Privacy;
